import { em, math } from 'polished'
import styled from 'styled-components'

import { H1Small as H1 } from 'styles/components/typography'

export const Wrapper = styled.div`
  padding-top: ${p => math(`${p.theme.blocks.menuHeight} + ${em(2)}`)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${p =>
      p.isTopIndent
        ? math(`${p.theme.blocks.menuHeightMd} + ${em(38)}`)
        : p.theme.blocks.menuHeightMd};
  }
`

export const H1Styled = styled(H1)`
  text-align: center;

  ${p => p.theme.mq.upMd} {
    ${p => p.isLessInfo && `display: none;`}
  }
`

export const SubtitleBox = styled.div`
  display: block;
  text-align: center;
  max-width: ${em(735)};
  margin: 0 auto ${em(20)};
  padding-left: ${p => p.theme.indents.baseIndentXs};
  padding-right: ${p => p.theme.indents.baseIndentXs};

  & b {
    font-family: ${p => p.theme.typography.mediumFont};
    font-weight: 400;
  }
`

export const TitleBox = styled.div`
  padding-top: ${em(20)};
  padding-bottom: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(40)};
    padding-bottom: ${em(20)};
  }
`

export const ButtonScrollBox = styled.div`
  margin-top: -${em(25)};
`
